import * as ActionType from "../actionTypes";

export default (state = {}, action) => {
  switch(action.type){
    case ActionType.REQUEST_EDIT_QUESTION :

        return{
            ...state,
            loading:true,
            error:false,
            errorInfo:null,
            response: null
            }
    case ActionType.RECEIVED_EDIT_QUESTION :
        return{
            ...state,
            loading:false,
            response:action.res,
            error:false,
            errorInfo:null
        }
    case ActionType.ERROR_EDIT_QUESTION:
        return{
            ...state,
            loading:false,
            error:true,
            errorInfo:action.err,
            response: null
        }
    case ActionType.GET_EDIT_QUESTION_DETAILS:
        return{
            ...state,
             editQuestion:true,
             questionIdInfo: action.editQuestionInfo
        }   
    case ActionType.CLEAR_EDIT_QUESTION:
        return {
        }
    case ActionType.CLEAR_GET_QUESTION:
         return{
             ...state,
             questionIdInfo:{},
             editQuestion:false,
         }    
    default : 
      return state    

  }
}